import React from 'react';
import './ContactFooter.css';

const EMAIL = 'sjderham@protonmail.com';

const ContactFooter = () => {
  return (
    <a className="contact-footer" href={`mailto:${EMAIL}`}>
      {EMAIL}
    </a>
  );
};

export default ContactFooter;
